import { BaseDataService } from './BaseDataService';
import { NotificationService } from '../../services';
import { BACKEND_ROOT } from '../../config/host-config';

export class ImportDataService extends BaseDataService<any> {
    constructor(notificationService: NotificationService) {
        super('Import', 'Import', notificationService);
    }

    public Calc(orgId?: number): Promise<any> {
        const endpoint = `${BACKEND_ROOT}/import/calc/${orgId !== undefined ? orgId : ''}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving statements.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
    
    public Surveys(orgId: number, surveyId: number): Promise<any> {
        const endpoint = `${BACKEND_ROOT}/import/surveyInstances/${orgId}/${surveyId}`;
        const init = this.buildRequestInit('POST');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving statements.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/api/ImportData.tsx